//BUYERS Listing
export const FETCH_CLERKS_LISTING_FAILURE = 'FETCH_CLERKS_LISTING_FAILURE';
export const FETCH_CLERKS_LISTING_SUCCESS = 'FETCH_CLERKS_LISTING_SUCCESS';

export const RESET = 'RESET';
